import React from "react";
import { UserDataProvider, useUserData } from "../context/UserDataProvider";
import { RouterProvider } from "react-router-dom";
import createRouter from "../router";
import HeimdallContext, { HeimdallContextProvider } from "../HeimdallContext";
import { isLoginPage } from "../context/auth";
import { NotificationProvider } from "./NotificationProvider";
import TranslationsProvider from "./TranslationsProvider";
import FetchProvider, { useFetch } from "./FetchProvider";
import BackendErrorDialog from "./BackendErrorDialog";
import Theme from "./Theme";
import DatePickerLocalizationProvider from "./DatePickerLocalizationProvider";
import LoadingScreen from "./LoadingScreen";

const DelayedRouterProvider = ({ context }: { context: HeimdallContext }) => {
    const userData = useUserData();
    const fetch = useFetch();

    const loginPage = isLoginPage(window.location.pathname);

    if (!loginPage && !userData) return <LoadingScreen />;

    const router = createRouter(context, userData, fetch);
    return (
        <RouterProvider
            router={router}
            future={{
                v7_startTransition: true,
            }}
        />
    );
};

export default function App({ context }: { context: HeimdallContext }) {
    return (
        <Theme>
            <HeimdallContextProvider context={context}>
                <TranslationsProvider>
                    <FetchProvider>
                        <UserDataProvider>
                            <DatePickerLocalizationProvider>
                                <BackendErrorDialog />
                                <NotificationProvider>
                                    <DelayedRouterProvider context={context} />
                                </NotificationProvider>
                            </DatePickerLocalizationProvider>
                        </UserDataProvider>
                    </FetchProvider>
                </TranslationsProvider>
            </HeimdallContextProvider>
        </Theme>
    );
}
